import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LockScreenService {

    private _lockScreen : boolean = false;

    constructor() {
    }

    set lockScreen(lockScreen : boolean) {
        this._lockScreen = lockScreen;
    }

    get lockScreen() : boolean {
        return this._lockScreen;
    }
}